import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconClock(rest) {
  return (
    <Icon viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </Icon>
  )
}
